import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const mentorshipData: NavItem[] = [
  {
    label: 'About',
    to: '/pages/mentorship/about'
  },
  {
    label: 'Documentation',
    to: '/pages/mentorship/documentation'
  },
  {
    label: 'Terms',
    to: '/pages/mentorship/terms'
  },
  {
    label: 'Process',
    to: '/pages/mentorship/process'
  },
  {
    label: 'Stats',
    to: '/pages/mentorship/stats'
  }
];
